// Presentation adapter: source data stays separate from the page template.
function runtimeSeconds(value){
 if(typeof value==='number')return Number.isFinite(value)&&value>=0?Math.floor(value):null;
 const text=String(value||'').replace(/^run\s*time\s*:\s*/i,'').trim();
 if(/^\d+:\d{2}(?::\d{2})?$/.test(text))return text.split(':').reduce((n,v)=>n*60+Number(v),0);
 const units=[...text.matchAll(/(\d+)\s*(hours?|minutes?|seconds?)/gi)];
 if(!units.length||text.includes('\n'))return null;
 return units.reduce((n,m)=>n+Number(m[1])*(m[2].toLowerCase().startsWith('hour')?3600:m[2].toLowerCase().startsWith('minute')?60:1),0);
}
function runtimeTimecode(value){
 const n=runtimeSeconds(value);if(n===null)return '';
 return [Math.floor(n/3600),Math.floor(n/60)%60,n%60].map(v=>String(v).padStart(2,'0')).join(':');
}
function releaseSummary(r,archive){
 const metadata=r.summary||{};
 const shortName=value=>String(value||'').split(/\s+·\s+|\s+at\s+/i)[0].trim();
 function credit(role){
  const original=(r.credits||[]).find(c=>c.role.toLowerCase()===role.toLowerCase());
  if(original)return shortName(original.name);
  const exact=(archive?.credits||[]).find(c=>c.role.toLowerCase()===role.toLowerCase());
  if(exact)return shortName(exact.name);
  const perTrack=(archive?.credits||[]).filter(c=>c.role.toLowerCase().startsWith(role.toLowerCase()+' ·')||(role==='Mixed by'&&/^Mixed & engineered ·/i.test(c.role)));
  return [...new Set(perTrack.map(c=>shortName(c.name)))].join('; ');
 }
 return [
  ['Year',metadata.year??r.displayYear??r.year],
  ['Label',metadata.label??r.label],
  ['Catalog number',metadata.catalog_number??r.fields?.['Catalog number']],
  ['Produced by',metadata.produced_by??credit('Produced by')],
  ['Mixed by',metadata.mixed_by??credit('Mixed by')],
  ['Mastered by',metadata.mastered_by??credit('Mastered by')],
  ['Runtime',runtimeTimecode(metadata.runtime_seconds??r.runtime)]
 ].filter(([,value])=>value!==undefined&&value!==null&&value!=='');
}

// Newlines are always explicit list boundaries. Preserve company-name ampersands.
function metadataItems(value,kind='credit'){
 const values=Array.isArray(value)?value:[value];
 return values.flatMap(value=>{
  let text=String(value??'').replace(/\r/g,'').trim();
  if(kind==='label')text=text.replace(/Tooth\s*&\s*Nail/gi,'Tooth __AMP__ Nail');
  return text.split(/\n|;|,|\s+&\s+|\s+and\s+/i).map(v=>v.replace(/__AMP__/g,'&').trim()).filter(Boolean);
 });
}
function compactRuntime(value){
 const n=runtimeSeconds(value);if(n===null)return '—';
 return n>=3600?runtimeTimecode(n):Math.floor(n/60)+':'+String(n%60).padStart(2,'0');
}
function releaseDateLabel(value){
 const match=String(value||'').match(/^(\d{4})-(\d{2})-(\d{2})/);
 return match?match[2]+'/'+match[3]+'/'+match[1]:String(value||'');
}
function releaseTrackCount(r){return r.trackEntries?.length?r.trackEntries.filter(t=>!t.hidden).length:r.withheld?(archiveData[r.id]?.spoiler?.tracks.length||0):r.tracks.length;}
function releaseFacts(r){
 const old=Object.fromEntries(releaseSummary(r,archiveData[r.id])),s=r.summary||{};
 const labels=metadataItems(old.Label,'label'),catalogs=metadataItems(old['Catalog number'],'catalog');
 const fact=(label,items)=>items.some(item=>String(item??'').trim())?'<div><dt>'+esc(label)+'</dt><dd>'+items.map(esc).join('<br>')+'</dd></div>':'';
 const total=releaseTrackCount(r),length=total+' '+(total===1?'Track':'Tracks')+' / '+compactRuntime(s.runtime_seconds??r.runtime);
 return '<div class="release-facts"><dl>'+fact('Release date',[releaseDateLabel(s.release_date)])+fact(labels.length>1?'Labels':'Label',labels)+fact(catalogs.length>1?'Cat. numbers':'Cat. number',catalogs)+fact('Length',[length])+'</dl><dl>'+fact('Produced by',metadataItems(old['Produced by']))+fact('Mixed by',metadataItems(old['Mixed by']))+fact('Mastered by',metadataItems(old['Mastered by']))+fact('Cover art by',metadataItems(s.cover_art_by))+'</dl></div>';
}
function trackTotalsMarkup(r){
 const n=runtimeSeconds(r.summary?.runtime_seconds??r.runtime),count=releaseTrackCount(r);
 const duration=n===null?'':(n>=3600?Math.floor(n/3600)+' hrs, ':'')+Math.floor(n/60)%60+' mins, '+n%60+' secs';
 return '<p class="track-totals">'+count+' '+(count===1?'Track':'Tracks')+(duration?' / &nbsp; '+duration:'')+'</p>';
}
